module.exports = __webpack_public_path__ + "img/Frame 71.72a9704b.svg";